// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const isQueryBuilderReport = objectOf({
  id: string,
  name: string,
  results_generated: string,
  can_delete: boolean,
  edited_at: string,
  created_by: string,
  last_edited_by: string,
  associated_dashboards: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
});

export const isEngagementQueryBuilderReportsResult = objectOf({
  reports: arrayOf(isQueryBuilderReport),
});
